import { ChangeDetectorRef, Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyService } from 'src/app/lazy.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { LoginServiceService } from '../service/login-service.service';

@Component({
    selector: 'app-quick-otp',
    templateUrl: './quick-otp.component.html',
    styleUrls: ['./quick-otp.component.scss'],
    standalone: false
})
export class QuickOTPComponent implements OnInit {

  @Output() emitBackEvent = new EventEmitter<any>();
  loginForm: FormGroup;
  submitted = false;
  otp:any = "";
  accountUrl:any = "";
  headerInfo: any = {};

 
  timer: number;
  showTimer: boolean = false;
  loginInfo:any = {};
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };

  constructor(
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    private loader: LoaderService,
    private alerts: AlertsService,
    private appService: AppService,
    public utilService: UtilService,
    public router:Router,
    public route:ActivatedRoute,
    public changeDetectorRef: ChangeDetectorRef,
    private loginService: LoginServiceService,
    private lazyService: LazyService,
    private storageService: StorageService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.headerInfo = this.appService.getAppHeader();
    if (this.route.snapshot.params["user_id"] != undefined && this.route.snapshot.params["id"]) {
      var userId = this.route.snapshot.params["user_id"];
      var downloadId = this.route.snapshot.params["id"];
      this.loginInfo.user_id = userId;
      this.loginInfo.download_id = downloadId;
      if (this.appService.getSessionId()) {
        this.redirectToDownload(userId,downloadId);
      }else{
        this.lazyService.loadStreamServer();
        this.sendOTP(userId,downloadId); 
      }
    }else{
      this.router.navigate(["/"]);
    }
  }

  redirectToDownload(userId,downloadId){
    const queryParams = {
      printType: this.route.snapshot.queryParams["printType"]
    };
    this.router.navigate([`/report-management/quick-download/${userId}/${downloadId}`],{ queryParams: queryParams });
  }

  resendOTP(){
    this.sendOTP(this.loginInfo.user_id,this.loginInfo.download_id)
  }

  sendOTP(userId,downloadId){    
      this.accountUrl = "";    
      if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') {
        this.accountUrl = window.location.hostname;
      }else{
        this.accountUrl =  prompt("Please enter Account Url");       
      }
      var args =  "context:auto_login,account_url:"+this.accountUrl+",user_id:"+userId+"";
      this.loader.showSpinner();
      this.baseService.get('send_otp_autologin', args, 'otp', 'account-management').subscribe(res => {
        this.loader.hideSpinner();
       
        if (res.errCode == -1) {
          this.timerFn();
          this.alerts.error(res.message);
        }
        else if (res.errCode == 0) {
          this.alerts.info("otpsuc")
          this.timerFn();
        }
      })
    
    
  }
 
 
  verifyOtp() {
    if(this.submitted){
      return;
    }
       
    this.loginInfo['account_url'] = this.accountUrl;
    this.loginInfo['password'] = this.otp;
    this.loginInfo["extra_data"]={"otpLogin":true};
   

    var loginInfo = this.loginService.encrypt(this.loginInfo);
    delete loginInfo["login_id"];
    delete loginInfo["download_id"];
    if (this.utilService.isMobile()) {
      loginInfo['user_agent'] = 'mobile';
    } else {
      loginInfo['user_agent'] = 'web'
    }
    loginInfo["resources"] = ["requested_downloads","masterupload"];
    loginInfo["actions"] = ["all"];
    this.submitted = true;
    this.loader.showSpinner();
    this.baseService.add(loginInfo, 'login',false,'account-management').subscribe(
      (data: any) => {
        this.loader.hideSpinner();
        this.submitted = false;
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          
        } else {
          if (data.resource != undefined && data.resource.length) {
            this.authenticationService.setUser(data.resource[0]);
            this.appService.setEncryptionKey(data.resource[0]);
            this.storageService.setData("auto_login",true,()=>{
              this.redirectToDownload(this.loginInfo["user_id"],this.loginInfo["download_id"]);
            })
            
          } else {
            this.alerts.error(data.message);
          }
          
        }
      }, error => {
        console.log(error);
        this.submitted = false;
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    );
  }
  
  onOtpChange(otp) {
    this.otp = otp;
  }
  timerFn() {
    this.timer = 120;
    this.showTimer = true;
    let timerInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000)
  }

}
